import qs from "qs";
import apiFarms from "../config/api_farms";
// import axios from "axios";
import getHeaders from "./getHeaders";
// import axios from "axios";

// const apiFarms = axios.create({
//   baseURL: "http://localhost:8082",
// });

export function getAllPicketsBySupplyDate(payload) {
  const { groupId, farmId, supplyDate, showAnimalStatisticsData } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/pickets/supplements/supply/list/pickets?supplyDate=${supplyDate}&showAnimalStatisticsData=${showAnimalStatisticsData ?? "false"}`,
    getHeaders(false, null),
  );
}

export function getDashboardDataService(payload) {
  const { groupId, farmId, parameters } = payload;

  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/pickets/supplements/supply/dashboard`,
    {
      params: {
        ...parameters,
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
      ...getHeaders(false, null),
    },
  );
}

export function findAll(payload) {
  const { groupId, farmId, page, size, sorter, filters } = payload;
  const orderDir = sorter?.order === "descend" ? "DESC" : "ASC";
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/pickets/supplements/supply` +
      `?page=${(page || 1) - 1}` +
      `&size=${size || 10}` +
      (sorter?.field ? `&sort=${sorter.field}&direction=${orderDir}` : "") +
      (filters ? `&search=${filters}` : ""),
    getHeaders(false, null),
  );
}

export function findLatest(payload) {
  const { groupId, farmId } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/pickets/supplements/supply/latest`,
    getHeaders(false, null),
  );
}

export function findAllBySupplyDate(payload) {
  const { groupId, farmId, supplyDate } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/pickets/supplements/supply?supplyDate=${supplyDate}`,
    getHeaders(false, null),
  );
}

export function findBySupplyDateAndSupplyNumber(payload) {
  const { groupId, farmId, supplyDate, supplyNumber } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/pickets/supplements/supply?supplyDate=${supplyDate}&supplyNumber=${supplyNumber}`,
    getHeaders(false, null),
  );
}

export function save(payload) {
  const { groupId, farmId, body } = payload;
  return apiFarms.put(
    `/bovexo/${groupId}/farms/${farmId}/pickets/supplements/supply`,
    body,
    getHeaders(false, null),
  );
}

export function destroyBySupplyDate(payload) {
  const { groupId, farmId, supplyDate } = payload;
  return apiFarms.delete(
    `/bovexo/${groupId}/farms/${farmId}/pickets/supplements/supply?supplyDate=${supplyDate}`,
    getHeaders(false, null),
  );
}
